import styled from "@emotion/styled";
import { Flex } from "@ugc-ui/lego";

export const FlexFieldsContainer = styled(Flex)<{ fullScreen?: boolean }>`
  flex-direction: column;
  height: ${({ fullScreen }) => (fullScreen ? "100%" : "auto")};
  justify-content: center;
  div {
    padding: 4px;
  }
`;

export const DescriptionFlexStyled = styled(Flex)`
  padding: 0 20px;
`;
